(function () {
  const currency = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  const newBadgeLifetimeMs = 24 * 60 * 60 * 1000;

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function imageUrl(src, width) {
    if (!src) return "";
    return `${src}${src.includes("?") ? "&" : "?"}width=${width}`;
  }

  function timeValue(value) {
    const parsed = Date.parse(value || "");
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function productFamilyKey(product) {
    const ean = String(product.ean || "").replace(/\D/g, "");
    if (ean.length >= 8) return `ean:${ean}`;
    const title = String(product.title || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
    return title ? `title:${title}` : `id:${product.id || product.handle || ""}`;
  }

  function stockRank(product) {
    if (product.available) return 3;
    if (product.preorder) return 2;
    return 1;
  }

  function productPrice(product) {
    return Number(product.price || 0);
  }

  function cheaperVisibleProduct(candidate, current) {
    if (!current) return candidate;
    const rankDiff = stockRank(candidate) - stockRank(current);
    if (rankDiff !== 0) return rankDiff > 0 ? candidate : current;
    const candidatePrice = productPrice(candidate);
    const currentPrice = productPrice(current);
    if (candidatePrice > 0 && currentPrice > 0 && candidatePrice !== currentPrice) {
      return candidatePrice < currentPrice ? candidate : current;
    }
    if (candidatePrice > 0 && currentPrice <= 0) return candidate;
    if (candidatePrice <= 0 && currentPrice > 0) return current;
    const candidateTime = timeValue(candidate.updated_at || candidate.created_at);
    const currentTime = timeValue(current.updated_at || current.created_at);
    if (candidateTime !== currentTime) return candidateTime > currentTime ? candidate : current;
    return Number(candidate.id || 0) > Number(current.id || 0) ? candidate : current;
  }

  function collapseProductFamilies(products) {
    const byFamily = new Map();
    const familyCounts = new Map();
    for (const product of products) {
      const key = productFamilyKey(product);
      familyCounts.set(key, (familyCounts.get(key) || 0) + 1);
      byFamily.set(key, cheaperVisibleProduct(product, byFamily.get(key)));
    }
    return Array.from(byFamily.entries()).map(([key, product]) => {
      product._genkiFamilyCount = familyCounts.get(key) || 1;
      return product;
    });
  }

  function isFsk18(product) {
    const haystack = [
      product.title,
      product.origin,
      ...(Array.isArray(product.type) ? product.type : [product.type]),
    ].join(" ").toLowerCase();
    return haystack.includes("hentai") || haystack.includes("18+");
  }

  function fskVerified() {
    const verified = localStorage.getItem("fsk18_verified");
    const verifiedTime = Number(localStorage.getItem("fsk18_time") || 0);
    return verified === "true" && verifiedTime && Date.now() - verifiedTime < 24 * 60 * 60 * 1000;
  }

  function revealFsk18(root) {
    root.querySelectorAll(".genki-showcase-card--fsk18").forEach((card) => card.classList.add("is-fsk18-open"));
  }

  function state(product) {
    if (product.preorder) return "preorder";
    if (product.available) return "available";
    return "soldout";
  }

  function stateLabel(product) {
    if (product.preorder) return "Vorbesteller";
    if (product.available) return "Verfügbar";
    return "Ausverkauft";
  }

  function promoBadgesMarkup(product) {
    const createdAt = timeValue(product.created_at);
    const age = Date.now() - createdAt;
    const isNew = createdAt > 0 && age >= 0 && age < newBadgeLifetimeMs;
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at || 0);
    const isSale = Boolean(product.sale) || (price > 0 && compareAt > price);
    const badges = [];

    if (isNew) {
      badges.push('<span class="genki-showcase-card__promo genki-showcase-card__promo--new">NEW</span>');
    }
    if (isSale) {
      badges.push('<span class="genki-showcase-card__promo genki-showcase-card__promo--sale">SALE</span>');
    }
    if (!badges.length) return "";
    return `<span class="genki-showcase-card__promos">${badges.join("")}</span>`;
  }

  function priceMarkup(product) {
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at || 0);
    if (price <= 0) return "";
    const prefix = product.price_varies || Number(product._genkiFamilyCount || 1) > 1 ? "Jetzt ab" : "Jetzt";
    const current = `${prefix} ${currency.format(price)}`;
    if (compareAt > price) {
      return `<div class="genki-showcase-card__price genki-showcase-card__price--sale">
        <strong>${current}</strong>
        <span>Vorher ${currency.format(compareAt)}</span>
      </div>`;
    }
    return `<div class="genki-showcase-card__price"><strong>${current}</strong></div>`;
  }

  function ratingMarkup(product) {
    return `<div class="genki-showcase-card__rating" data-genkidama-card-rating data-product-id="${escapeHtml(product.id)}" data-product-handle="${escapeHtml(product.handle)}" aria-label="Bewertungen werden geladen"><span aria-hidden="true">☆☆☆☆☆</span></div>`;
  }

  function releaseInfoMarkup(product) {
    if (!product.preorder || !product.release_date) return "";
    return `<div class="genki-showcase-card__release-info">
      <span>Release</span>
      <strong>${escapeHtml(product.release_date)}</strong>
    </div>`;
  }

  async function genkiIndexFetch(url) {
    // ERSATZWEG (05.08.): Die Kundendomain liefert fuer grosse JSON-Assets
    // zeitweise 502/504 (Proxy/CDN-Schicht). Erst normal versuchen, bei
    // Fehler direkt vom Shopify-CDN laden. FAIL-OPEN bleibt erhalten.
    const requestUrl = new URL(url, window.location.href);
    if (/-first\.json$/.test(requestUrl.pathname)) requestUrl.searchParams.set("_genki_index_t", String(Date.now()));
    try {
      const r = await fetch(requestUrl.toString(), { credentials: "same-origin" });
      if (r.ok) return r;
    } catch (e) { /* weiter zum Ersatzweg */ }
    const m = String(url || "").match(/\/cdn\/shop\/(t\/\d+\/assets\/[^"']+)$/);
    if (m) {
      const direkt = "https://figuna.myshopify.com/cdn/shop/" + m[1];
      const r2 = await fetch(direkt, { mode: "cors" });
      if (r2.ok) return r2;
    }
    throw new Error("Genkidama-Index nicht ladbar");
  }

  function renderCard(product, index) {
    const productState = state(product);
    const fsk18 = isFsk18(product);
    const section = document.querySelector(".genki-home-new");
    const actionLabel = product.preorder
      ? section?.dataset.preorderAction || "Vorbestellen"
      : product.available
        ? section?.dataset.availableAction || "In den Korb"
        : section?.dataset.soldoutAction || "Ansehen";
    const image = product.image
      ? `<img class="genki-showcase-card__image${fsk18 ? " genki-showcase-card__image--fsk18" : ""}" src="${escapeHtml(imageUrl(product.image, 420))}" alt="${escapeHtml(product.title)}" loading="${index < 4 ? "eager" : "lazy"}" decoding="async">`
      : "";
    return `<li class="genki-showcase-card genki-showcase-card--${productState}${fsk18 ? " genki-showcase-card--fsk18" : ""}">
      <a class="genki-showcase-card__media" href="${escapeHtml(product.url)}"${fsk18 ? ' data-fsk18="true"' : ""}>
        ${image}
        ${fsk18 ? `<span class="genki-showcase-card__fsk"><strong>FSK 18+</strong><small>Klicken zum Oeffnen</small></span>` : ""}
        ${promoBadgesMarkup(product)}
        <span class="genki-showcase-card__ribbon">${stateLabel(product)}</span>
      </a>
      <div class="genki-showcase-card__body">
        <a class="genki-showcase-card__name" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
        ${product.vendor && product.vendor !== "-" ? `<div class="genki-showcase-card__vendor">${escapeHtml(product.vendor)}</div>` : ""}
        ${releaseInfoMarkup(product)}
        ${priceMarkup(product)}
        <div class="genki-showcase-card__actions">
          <a class="genki-showcase-card__button" href="${escapeHtml(product.url)}">${escapeHtml(actionLabel)}</a>
        </div>
        ${ratingMarkup(product)}
      </div>
    </li>`;
  }

  function shelfProducts(products, shelf, limit) {
    if (shelf === "preorder") {
      return collapseProductFamilies(products.filter((product) => product.preorder))
        .sort((a, b) => timeValue(b.created_at) - timeValue(a.created_at) || Number(b.id || 0) - Number(a.id || 0))
        .slice(0, limit);
    }
    if (shelf === "available") {
      return collapseProductFamilies(products.filter((product) => product.available))
        .sort((a, b) => timeValue(b.created_at) - timeValue(a.created_at) || Number(b.id || 0) - Number(a.id || 0))
        .slice(0, limit);
    }
    return collapseProductFamilies(products.filter((product) => product.available || product.preorder))
      .sort((a, b) => Number(b.sold || 0) - Number(a.sold || 0) || timeValue(b.created_at) - timeValue(a.created_at))
      .slice(0, limit);
  }

  function updateSliderButtons(shelf) {
    const rail = shelf.querySelector(".genki-home-new__rail");
    const prev = shelf.querySelector('[data-genki-home-slide="prev"]');
    const next = shelf.querySelector('[data-genki-home-slide="next"]');
    if (!rail || !prev || !next) return;

    const canScroll = rail.scrollWidth > rail.clientWidth + 2;
    prev.hidden = !canScroll;
    next.hidden = !canScroll;
    if (!canScroll) return;

    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  }

  function bindSlider(section) {
    section.querySelectorAll(".genki-home-new__shelf").forEach((shelf) => {
      const rail = shelf.querySelector(".genki-home-new__rail");
      if (!rail || shelf.dataset.sliderBound === "true") return;
      shelf.dataset.sliderBound = "true";

      shelf.addEventListener("click", (event) => {
        const button = event.target.closest("[data-genki-home-slide]");
        if (!button) return;
        const direction = button.dataset.genkiHomeSlide === "prev" ? -1 : 1;
        const step = Math.max(rail.clientWidth * 0.96, 260);
        rail.scrollBy({ left: direction * step, behavior: "smooth" });
      });

      rail.addEventListener("scroll", () => updateSliderButtons(shelf), { passive: true });
      window.addEventListener("resize", () => updateSliderButtons(shelf));
      requestAnimationFrame(() => updateSliderButtons(shelf));
    });
  }

  async function init(section) {
    async function loadIndex(url) {
      const response = await genkiIndexFetch(url);
      if (!response.ok) throw new Error(`Index request failed: ${response.status}`);
      const data = await response.json();
      if (data.chunked === true) {
        if (!Array.isArray(data.chunks) || !data.chunks.length) throw new Error("Index chunks missing");
        data.products = [];
        for (const chunkName of data.chunks) {
          const chunk = await (await genkiIndexFetch(new URL(chunkName, url).toString())).json();
          if (chunk.generated_at !== data.generated_at || !Array.isArray(chunk.products)) throw new Error("Index chunks mismatch");
          data.products.push(...chunk.products);
        }
      }
      if (!Array.isArray(data.products) || data.products.length !== data.product_count) throw new Error("Index count mismatch");
      return data;
    }
    let data;
    try {
      data = await loadIndex(section.dataset.indexUrl);
    } catch (error) {
      if (!section.dataset.indexFallbackUrl) throw error;
      data = await loadIndex(section.dataset.indexFallbackUrl);
    }
    const limit = Math.max(4, Number(section.dataset.limit || 8));
    const renderShelves = (products) => {
      section.querySelectorAll(".genki-home-new__shelf").forEach((shelf) => {
        const grid = shelf.querySelector(".genki-home-new__rail");
        if (!grid) return;
        const items = shelfProducts(products, shelf.dataset.shelf, limit);
        grid.innerHTML = items.map((product, index) => renderCard(product, index)).join("");
        requestAnimationFrame(() => updateSliderButtons(shelf));
      });
      window.GenkidamaCardRatings?.load?.(section);
      if (fskVerified()) revealFsk18(section);
    };
    renderShelves(data.products);
    bindSlider(section);
    if (data.segment === "first") {
      const readyUrl = new URL(section.dataset.indexUrl.replace(/-first\.json(?=\?|$)/, "-ready.json"), window.location.href);
      readyUrl.searchParams.set("genki_build", data.generated_at);
      window.requestAnimationFrame(() => window.setTimeout(() => {
        loadIndex(readyUrl.toString()).then((ready) => {
          // The index daemon can publish a newer ready segment while this page is open.
          if (ready.segment !== "ready") throw new Error("Index segment mismatch");
          renderShelves(ready.products);
        }).catch((error) => console.warn("Genkidama showcase ready index failed:", error));
      }, 200));
    }
    section.addEventListener("click", (event) => {
      const link = event.target.closest("[data-fsk18='true']");
      if (!link || fskVerified()) return;
      event.preventDefault();
      if (!confirm("ALTERSPRUEFUNG\n\nDieser Bereich enthaelt Artikel fuer Erwachsene (FSK 18+).\n\nBist du ueber 18 Jahre alt?")) return;
      localStorage.setItem("fsk18_verified", "true");
      localStorage.setItem("fsk18_time", String(Date.now()));
      revealFsk18(section);
    });
  }

  function boot() {
    document.querySelectorAll(".genki-home-new").forEach((section) => {
      init(section).catch((error) => console.warn("Genkidama showcase inactive:", error));
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
